import React, { useEffect, useState } from 'react';
import axios from "axios";
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import './EvaluationAnswerGroupsView.css';

import { apiUrl } from '../../../utility/Connections';

import { Layout, Divider, Button } from 'antd';
import LoadingOverlay from '../../../components/loadingOverlay/loadingOverlay';
import FormEvaluationAnswerGroup from '../../../components/formEvaluationAnswerGroup/formEvaluationAnswerGroup';
import { PlusOutlined } from '@ant-design/icons';
import FormEvaluationAnswerGroupText from '../../../components/formEvaluationAnswerGroup/formEvaluationAnswerGroupText';
const { Content } = Layout;

const EvaluationAnswerGroupsView = () => {

    const [showLoading, setShowLoading] = useState(false);
    const [loadingText, setLoadingText] = useState(null);
    const [isEditing, setIsEditing] = useState(false);
    const [evaluationAnswerGroups, setEvaluationAnswerGroups] = useState([]);
    const [evaluationAnswerGroup, setEvaluationAnswerGroup] = useState({})
    const [organizationsData, setOrganizationsData] = useState([]);

    useEffect(() => {
        getOrganizations();
        getEvaluationAnswersGroups();
    }, []);

    const getOrganizations = () => {
        setShowLoading(true);
        setLoadingText("Cargando organizaciones...")
        const token = localStorage.getItem('access_token');
        const headers = {
            headers: {
                'Authorization': `Bearer ${token}`
            },
        }
        axios
            .get(`${apiUrl}/organizations/get-organizations-data/`, headers)
            .then(function (response) {
                setOrganizationsData(response.data);
                setShowLoading(false)
                setLoadingText(null)
            })
            .catch(function (error) {
                console.error('There was an error!', error);
                setShowLoading(false)
                setLoadingText(null)
            });
    }

    const getEvaluationAnswersGroups = () => {
        setShowLoading(true);
        setLoadingText("Cargando escalas de respuesta...")

        const token = localStorage.getItem('access_token');
        const headers = {
            headers: {
                'Authorization': `Bearer ${token}`
            },
        }

        axios.get(`${apiUrl}/evaluation-answer-groups/get-evaluation-answer-groups/`, headers)
            .then(function (response) {
                const data = response.data;
                setEvaluationAnswerGroups(data);
                setShowLoading(false);
            })
            .catch(function (error) {
                console.error('There was an error!', error);
                setShowLoading(false);
            });
    }

    // Función para agregar un nuevo registro de servicio
    const addService = () => {
        setIsEditing(true);
        resetEvaluationAnswerGroup();
    }

    const resetEvaluationAnswerGroup = () => {
        setEvaluationAnswerGroup({
            "eag_id": null,
            "eag_title": "",
            "eag_description": "",
            "eag_type": null,
            "eag_min_value": null,
            "eag_max_value": null,
            "eag_target": null,
            "eag_is_active": true,
            "eag_options": [],
        });
    }

    const createEvaluationAnswerGroup = (newEvaluationAnswerGroup) => {
        setShowLoading(true);
        setLoadingText("Agregando escala...")

        const formData = new FormData();

        formData.append("eag_title", newEvaluationAnswerGroup.eag_title);
        formData.append("eag_description", newEvaluationAnswerGroup.eag_description);
        formData.append("eag_type", newEvaluationAnswerGroup.eag_type);
        formData.append("eag_min_value", newEvaluationAnswerGroup.eag_min_value);
        formData.append("eag_max_value", newEvaluationAnswerGroup.eag_max_value);
        formData.append("eag_target", newEvaluationAnswerGroup.eag_target);
        formData.append("eag_is_active", true);

        // 👇 Aquí conviertes el array en un JSON string
        formData.append("eag_options", JSON.stringify(newEvaluationAnswerGroup.eag_options));

        const token = localStorage.getItem('access_token');
        const headers = {
            headers: {
                'Authorization': `Bearer ${token}`
            },
        }

        axios.post(`${apiUrl}/evaluation-answer-groups/create-evaluation-answer-group/`, formData, headers)
            .then(function (response) {
                showSwal(response.data.message, 2, "Correcto");
                resetEvaluationAnswerGroup();
                setIsEditing(false);
                setShowLoading(false);
                getEvaluationAnswersGroups();
            })
            .catch(function (error) {
                showSwal(error, 0, "Error")
                console.error('There was an error!', error);
                setShowLoading(false);
            });
    }

    const updateEvaluationAnswerGroup = (newEvaluationAnswerGroup) => {
        setShowLoading(true);
        setLoadingText("Guardando escala...")

        let data = {
            "eag_id": newEvaluationAnswerGroup.eag_id,
            "eag_title": newEvaluationAnswerGroup.eag_title,
            "eag_description": newEvaluationAnswerGroup.eag_description,
            "eag_type": newEvaluationAnswerGroup.eag_type,
            "eag_min_value": newEvaluationAnswerGroup.eag_min_value,
            "eag_max_value": newEvaluationAnswerGroup.eag_max_value,
            "eag_target": newEvaluationAnswerGroup.eag_target || 0,
            "eag_is_active": newEvaluationAnswerGroup.eag_is_active,
            "eag_options": JSON.stringify(newEvaluationAnswerGroup.eag_options),
        }

        const token = localStorage.getItem('access_token');
        const headers = {
            headers: {
                'Authorization': `Bearer ${token}`
            },
        }

        axios.put(`${apiUrl}/evaluation-answer-groups/update-evaluation-answer-group/`, data, headers)
            .then(function (response) {
                showSwal(response.data.message, 2, "Correcto");
                getEvaluationAnswersGroups();
                resetEvaluationAnswerGroup();
                setIsEditing(false);
                setShowLoading(false);
            })
            .catch(function (error) {
                showSwal(error, 0, "Error")
                console.error('There was an error!', error);
                setShowLoading(false);
            });
    }

    const handleEdit = (group) => {
        setEvaluationAnswerGroup(group);  // Setea el grupo seleccionado
        setIsEditing(true);               // Muestra el formulario
    };

    const handleDelete = (group) => {
        Swal.fire({
            title: '¿Estás seguro?',
            text: "Esta acción no se puede deshacer",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#012E40',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {
                const token = localStorage.getItem('access_token');
                const headers = {
                    headers: {
                        'Authorization': `Bearer ${token}`
                    },
                }

                axios.delete(`${apiUrl}/evaluation-answer-groups/delete/${group.eag_id}/`, headers)
                    .then(() => {
                        showSwal("Eliminado correctamente", 2, "Correcto");
                        getEvaluationAnswersGroups();
                    })
                    .catch(err => {
                        console.error(err);
                        showSwal("Ocurrió un error al eliminar", 0, "Error");
                    });
            }
        });
    };

    const showSwal = (text, type, title) => {
        let swalType = "";
        if (type === 0) {
            swalType = "error";
        }
        if (type === 1) {
            swalType = "warning";
        }
        if (type === 2) {
            swalType = "success";
        }
        withReactContent(Swal).fire({
            title: title,
            icon: swalType,
            text: text,
            confirmButtonColor: "#012E40",
            cancelButtonColor: "#FF4D4F",
        })
    }

    return <div className='main-container'>
        {
            showLoading && <LoadingOverlay text={loadingText} showProgress={false} progress={null} />
        }
        <Content className='main-subcontainer main-subcontainer-column'>
            {
                !isEditing && <div className='layout-content'>
                    <Button type="primary" onClick={addService} style={{ marginBottom: "16px" }} icon={<PlusOutlined />} >
                        Agregar escala de respuesta
                    </Button>
                    {
                        evaluationAnswerGroups.length > 0 && <Divider />
                    }
                    {
                        evaluationAnswerGroups.length > 0 && <h2>Listado de escalas</h2>
                    }
                    {
                        evaluationAnswerGroups.map((item, index) => {
                            return (
                                <div key={index} style={{ marginBottom: "20px" }}>
                                    <FormEvaluationAnswerGroupText
                                        index={index}
                                        evaluationAnswerGroup={item}
                                        showEdit={true}
                                        onEdit={handleEdit}
                                        onDelete={handleDelete}
                                    />
                                    {
                                        index != evaluationAnswerGroups.length-1 && <Divider />
                                    }
                                </div>
                            )
                        })
                    }
                </div>
            }
            {
                isEditing && <div className='layout-content'>
                    <FormEvaluationAnswerGroup evaluationAnswerGroup={evaluationAnswerGroup} setIsEditing={setIsEditing} createEvaluationAnswerGroup={createEvaluationAnswerGroup} updateEvaluationAnswerGroup={updateEvaluationAnswerGroup} organizationsData={organizationsData} />
                </div>
            }
        </Content>
    </div>
}

export default EvaluationAnswerGroupsView;